const RECORD_SOURCE_ICON_HEIGHT = '12.5px';
const RECORD_SOURCE_ICON_WIDTH = '12.5px';

// eslint-disable-next-line import/prefer-default-export
export const RECORD_SOURCE_ICON_SIZE = {
  height: RECORD_SOURCE_ICON_HEIGHT,
  width: RECORD_SOURCE_ICON_WIDTH
};
